// extracted by mini-css-extract-plugin
export default {"current_line":"S1_GivePlan_current_line__cffq1","title":"S1_GivePlan_title__75GVY","details":"S1_GivePlan_details__eIbuQ"};